import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ChallengesNavigator } from '../elements/challenges-navigator';

const cls = classNames('slice-challenges-navigator');

// -------- Types -------->

// -------- Props -------->

export type SliceChallengesNavigatorProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceChallengesNavigatorDefaultProps: Omit<SliceChallengesNavigatorProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(ChallengesNavigator)<ContainerProps>`${ContainerStyles}`,
};

export const SliceChallengesNavigator: Shapeable.FC<SliceChallengesNavigatorProps> = (props) => {
  const { className, children, entity } = props;
  
  return (
    <My.Container className={cls.name(className)} />
  )
};

SliceChallengesNavigator.cls = cls;